module.exports = __webpack_public_path__ + "media/images/icons/login-google-5bc358c2bf9fc71597c31d3b51533142.svg";